// Town names arrive from several readers — a booking, a pasted list, research,
// a plan — and outside Latin-script countries they are written in two
// languages: "Zhengzhou (郑州)". A booking may still say "Shanghai" where a
// plan says "Shanghai (上海)". Compare towns by this key, never by the string.

/** "Zhengzhou (郑州)", "Zhengzhou 郑州" and "zhengzhou" → "zhengzhou". A name with no Latin part keys on itself: "郑州". */
export function townKey(name: string | null | undefined): string {
  if (!name) return '';
  const whole = name.trim().toLowerCase();
  const latin = whole
    .replace(/\([^)]*\)/g, ' ')
    .replace(/[^\p{Script=Latin}\d\s'’.-]/gu, ' ')
    .replace(/\s+/g, ' ')
    .trim();
  return latin || whole;
}

export function sameTown(a: string | null | undefined, b: string | null | undefined): boolean {
  const ka = townKey(a);
  return !!ka && ka === townKey(b);
}
